import Event from './Event'
import View from '../Views/Calendar'
import ListView from '../Views/Calendar/List'
import MonthView from '../Views/Calendar/Month'

export default class Calendar {
    constructor(config = {}) {
        if (config.timezone !== undefined) { 
            this.timezone = config.timezone;
        }
        this.eventCallbacks = config.eventCallbacks || [];
        this.events = {}
        this.views = []
        this.eventTypes = {}
    }

    addEvent(event) {
        if (!(event instanceof Event) || !event.isValid()) {
            throw Error('event must be a valid Event Object')
        }
        if (event.type && !this.eventTypes[event.type]) {
            this.eventTypes[event.type] = true
        }
        this.events[event.id] = event
    }

    addEvents(events) {
        const backup_events = this.events
        try {
            events.forEach((event) => {
                this.addEvent(event)
            })
        } catch(e) {
            // roll back on error
            this.events = backup_events
            throw Error('All events must be valid Event Objects!')
        }
    }

    addView(view) {
        if (!(view instanceof View)) {
            throw Error('view must be a valid CalendarView Object')
        }
        this.views.push(view)
    }

    addListView(identifier) {
        const list = new ListView(this, identifier)
        this.addView(list)
        return list
    }

    addMonthView(identifier) {
        const month = new MonthView(this, identifier)
        this.addView(month)
        return month
    }

    filterEvents() {
        this.views.forEach((view) => {
            view.updateAllEvents()
        })
    }
}
